import { Drawer } from "@mui/material";

/**
 * Componente contenedor responsivo para el sidebar
 */
const ResponsiveSidebarContainer = ({
  isSmallScreen,
  open,
  onClose,
  children,
}) => {
  if (isSmallScreen) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        variant="temporary"
        anchor="left"
        ModalProps={{
          keepMounted: true,
          disablePortal: true,
        }}
        PaperProps={{
          sx: {
            width: 420,
            maxWidth: "90vw",
            height: "100%",
            zIndex: (theme) => theme.zIndex.modal + 1,
          },
        }}
      >
        {children}
      </Drawer>
    );
  }

  return children;
};

export default ResponsiveSidebarContainer;
